@if (null != landLineList) {
  <div class="lines-list-area">
    @if (selectedLandLine) {
      <div class="choice-line-concerned-area" [ngClass]="{'pointer-cursor': selectedProcedure === null || selectedProcedure == ''}" (click)="linesListVisibility()">
        <div class="line-header">
          <div class="selected-line-desc">
            Ligne :
              <app-dot [landLine]="selectedLandLine" [ngStyle]="{position: 'relative', top: '9px'}"></app-dot>
              <span>{{ selectedLandLine.phoneNumber }}</span>
              <span class="line-label">{{ selectedLandLine.comment.substr(0, 25) }}</span>
          </div>
          @if (landLineList.length > 1 && (selectedProcedure == null || selectedProcedure == '')) {
            <div class="change-line-select">
              <span class="change-line-select_txt">Changer de ligne</span>
              @if (landLineList.length > 1) {
                <img src="../../../../../assets/images/icons/{{ arrowImage }}.png">
              }
            </div>
          }
          @if (selectedProcedure && selectedProcedure !== '') {
            <div class="change-line-select-dummy"></div>
            }<!--.change-line-select-->
          </div>
        </div>
        }<!--.choice-line-concerned-area-->
        <app-modal-land-lines-list [landLineList]="landLineList" [visibility]="modalVisibility" (closedListLines)="listLinesStatus($event)"></app-modal-land-lines-list>
        <div class="tabs-area">
          <nav>
            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
              <a class="nav-item nav-link left-border-tab {{ consumptionTab }}" (click)="setActiveTab('suiviconso', false)" id="nav-consumption-tab"
                data-toggle="tab" href="#nav-consumption" role="tab" aria-controls="nav-consumption" aria-selected="true"><span class="nav-icon suivi-conso-icon"></span><span class="nav-txt">SUIVI CONSO</span></a>
                <a class="nav-item nav-link left-border-tab {{ documentsTab }}" (click)="setActiveTab('infos', false)" id="nav-documents-tab"
                  data-toggle="tab" href="#nav-documents" role="tab" aria-controls="nav-documents" aria-selected="false"><span class="nav-icon info-doc-icon"></span><span class="nav-txt">INFOS et DOCUMENTS</span></a>
                  <a class="nav-item nav-link left-border-tab {{ lineManagementTab }}" (click)="setActiveTab('gestion', false)" id="nav-line-management-tab"
                    data-toggle="tab" href="#nav-line-management" role="tab" aria-controls="nav-line-management" aria-selected="false"><span class="nav-icon gestion-ligne-icon"></span><span class="nav-txt">GESTION DE MA LIGNE</span></a>
                  </div>
                </nav>
                <!-- ************************************************************************************  Suivi conso ******************************************  ****************************************** -->
                <div class="tab-content p-3" id="nav-tabContent">
                  <div class="tab-pane fade show {{ consumptionTab }}" id="nav-consumption" role="tabpanel" aria-labelledby="nav-consumption-tab">
                    <app-land-line-consumption [selectedLandLine]="selectedLandLine"></app-land-line-consumption>
                  </div>
                  <!-- ************************************************************************************  Info et documents ******************************************  ****************************************** -->
                  <div class="tab-pane fade show {{ documentsTab }}" id="nav-documents" role="tabpanel" aria-labelledby="nav-documents-tab">
                    @if (documentsTab) {
                      <app-land-line-details></app-land-line-details>
                    }
                  </div>
                  <!-- ************************************************************************************  Gestion de ma ligne ******************************************  ****************************************** -->
                  <div class="tab-pane fade show {{ lineManagementTab }}" id="nav-line-management" role="tabpanel" aria-labelledby="nav-line-management-tab">
                    @if (lineManagementTab) {
                      <app-land-line-management [procedureInParam]="procedureInParam"></app-land-line-management>
                    }
                  </div>
                  <!-- ************************************************************************************  Notifications ******************************************  ****************************************** -->
                  <!--            <div class="tab-pane fade show {{ notificationsTab }}" id="nav-notifications" role="tabpanel" aria-labelledby="nav-notifications-tab" *ngIf="notificationsPaginator.data.length > 0">-->
                  <!--                <app-notifications [notificationsPaginator]="notificationsPaginator" [selectedLine]="selectedLandLine" [type]="'msisdn'"></app-notifications>-->
                <!--            </div>-->
              </div>
            </div><!--.tabs-area-->
          </div>
          }<!--.lines-list-area-->
          @if (null === landLineList) {
            <div class="text-center mt-4 pt-3">Aucune ligne n'est associée à ce compte.</div>
          }

          <app-frequently-questions [faq]="faqPageCode"></app-frequently-questions>
